import { IFinalizarRequisicaoCompraUseCase } from "../../../presentation/useCases/update/finalizar_requisicao_compra_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * FinalizarRequisicaoCompraUseCase
 */

export class FinalizarRequisicaoCompraUseCase implements IFinalizarRequisicaoCompraUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async finalizarRequisicaoCompra(
    idRequisicaoCompra: number,
  ): Promise<void> {
    await this.repository.finalizarRequisicaoCompra(
      idRequisicaoCompra,
    );
  }
}
